import {MultiOrderHistoryPage} from '../../../summary/multi-order-history/multi-order-history';
import {ByodSummaryPage} from '../../../summary/byod-summary/byod-summary';
import {Component, Injector, OnInit} from '@angular/core';
import {Keyboard} from '@ionic-native/keyboard/ngx';
import {BasePaymentPage} from '../../../../core/base/base-payment-page';
import {SdkNativeOepayService} from '../../../../core/services/sdk-native-oepay-service';

declare var Stripe: any;

/*
  Generated class for the ByodSummary page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-oepay-payment',
    templateUrl: 'oepay-payment.html',
    styleUrls: ['oepay-payment.scss']
})
export class OepayPaymentPage extends BasePaymentPage implements OnInit {

    oepayToken: string;

    stripe: any;
    card: any;
    customer: any = {};

    constructor(private injector: Injector, public sdkNativeOepayService: SdkNativeOepayService, public keyboard: Keyboard) {

        super(injector);

        this.stripe = this.paymentService.getStripe();
        this.charge['returnUrl'] = this.getRedirectPrefix() + '/status/success/';
        this.charge['cancelUrl'] = this.getRedirectPrefix() + '/status/fail';

        // this.payment = this.getNavParams("payment");
    }

    static getPageUrl() {
        return 'oepay';
    }

    ngOnInit() {
        super.ngOnInit();

    }

    ionViewWillLeave() {
        this.keyboard.hide();
    }

    public pageName(): string {
        return '/mpgs-credit-card-payment';
    }


    sendOrder() {
        if (!this.checkInfo()) {
            return;
        }

        this.loading(true);
        if (this.multOrderManager.enableMutlOrder || this.orderService.isCourt) {
            this.orderService.postMultiOrderWithPaymentObject(this.orders, this.charge).subscribe((json) => {
                this.loading(false);
                console.log(json);
                const token = json['charge'] && json['charge']['token'] ? json['charge']['token'] : null;
                if (token && this.sdkNativeOepayService.isAvailable()) {
                    this.oepayHandling(token);
                } else {
                    const paymentInfo = {lang: this.t.currentLang, hideHistory: this.getNavParams('hideHistory')};
                    this.configService.putPreference('paymentInfo', paymentInfo);
                    window.location.href = json['charge']['paymentUrl'];

                }
                // this.testpayment(json["data"][0]["extra"]["mpgs"]["session"]["id"],json["data"][0]["id"]);
            }, (err) => {
                this.loading(false);
                this.showError(err);
            });

        } else {
            this.orderService.postOrderWithPaymentObject(this.orders[0], this.charge).subscribe((json) => {
                this.loading(false);
                const token = json['charge'] && json['charge']['token'] ? json['charge']['token'] : null;
                if (token && this.sdkNativeOepayService.isAvailable()) {
                    this.oepayHandling(token);
                } else {
                    const paymentInfo = {lang: this.t.currentLang, hideHistory: this.getNavParams('hideHistory')};
                    this.configService.putPreference('paymentInfo', paymentInfo);
                    window.location.href = json['charge']['paymentUrl'];

                }

            }, (err) => {
                this.loading(false);
                this.showError(err);
            });
        }


    }

    oepayHandling(token) {
        const params = {};

        params['octopustoken'] = token;

        this.sdkNativeOepayService.requestPay(params, () => {
                let page: any;
                this.popToRoot();
                if (this.multOrderManager.enableMutlOrder) {

                    page = MultiOrderHistoryPage;
                } else {

                    page = ByodSummaryPage;

                }

                this.push(page).then(() => {
                    this.orderService.clear();
                    if (this.multOrderManager.enableMutlOrder) {
                        this.multOrderManager.clearAll();
                    }
                });

            }
        );
    }


}
